<template>
    <IQOS>
        <template v-slot:header>
            {{ $t('integrations.poster_status.title') }} <span class="c-green" v-if="isEnabled">
                - {{ $t('integrations.poster_status.active') }}
            </span>
        </template>
        <div v-if="isEnabled">
            <!-- <p class="comment pt-0 c-green">
                {{ $t('integrations.poster_status.active')}}
            </p> -->
            <p class="comment pt-0 c-grey">
                {{ $t('integrations.poster_status.account_id') }} {{posterData.account}}
            </p>
            <DashboardButton class="iqos-group-item iqos-button-right " variant="danger" @click="poster_delete_modal = true">
                {{ $t('integrations.poster_status.disable') }}
            </DashboardButton>
        </div>

        <div v-else>
            <p class="comment pt-0 c-gray">
                {{ $t('integrations.poster_status.description') }}
            </p>
            <p class="comment pt-0 c-orange" v-if="wasDisconnected">
                {{ $t('integrations.poster_status.was_disconncted')}}
            </p>
            <DashboardButton class="iqos-button-right iqos-group-item" @click="activate">
                {{ $t('integrations.poster_status.connect') }}
            </DashboardButton>
        </div>

        <InfoModal v-if="poster_delete_modal" @close="poster_delete_modal = false">
            {{ $t('integrations.poster_status.disable_modal') }}
        </InfoModal>
    </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'

import DashboardButton from "@/components/DashboardButton.vue"

import InfoModal from "@/components/modals/InfoModal.vue"

export default {
    data() {
        return {
            poster_delete_modal: false
        }
    },
    computed: {
        isEnabled() {
            return !!this.$store.state.cafe.poster;
        },
        posterData() {
            if (!this.isEnabled) return {};
            return this.$store.state.cafe.poster;
        },
        wasDisconnected() {
            return this.$store.state.cafe.poster_disconnected_at;
        }
    },
    methods: {
        activate() {
            window.location.href = '/api/poster/start';
        }
    },
    components: {
        IQOS,
        DashboardButton,
        InfoModal
    }
}
</script>

<style>

</style>